module.exports = __webpack_public_path__ + "static/media/programDashboardIcon.b10dac52.png";